/* tslint:disable */

declare var Object: any;
export interface SubscribeInterface {
  "email"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Subscribe implements SubscribeInterface {
  "email": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: SubscribeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Subscribe`.
   */
  public static getModelName() {
    return "Subscribe";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Subscribe for dynamic purposes.
  **/
  public static factory(data: SubscribeInterface): Subscribe{
    return new Subscribe(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Subscribe',
      plural: 'Subscribes',
      path: 'Subscribes',
      idName: 'id',
      properties: {
        "email": {
          name: 'email',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
